import { Box } from "rebass/styled-components";
import {
  ClipThumbnail,
  MaxWidthContainer,
  StyledWrapper,
} from "../../styledComponents";
import { IClip } from "MVVM/@types";
import { TransitTime } from "MVVM/Components/TransitTime";

export const Pending = ({
  clip,
  refetchClip,
}: {
  clip: IClip;
  refetchClip: () => void;
}) => {
  return (
    <StyledWrapper
      justifyContent={"center"}
      alignItems={"center"}
      data-testid="spectating-wrapper"
    >
      <MaxWidthContainer>
        <ClipThumbnail snapshot={clip.thumbnailStandardUrl} />
        <Box backgroundColor={"navy"} style={{ borderRadius: "9px" }}>
          <TransitTime
            clip={clip.internalId}
            refetchClip={refetchClip}
            clipStatus={clip.status}
          />
        </Box>
      </MaxWidthContainer>
    </StyledWrapper>
  );
};
